import { CheckCircleTwoTone, ClockCircleTwoTone, CloseCircleTwoTone } from "@ant-design/icons";
import { theme } from "antd";
import type { GlobalToken } from "antd";
import type { RefundResultStatus } from "api/responses";

const { useToken } = theme;

function getRefundStatusDisplay(status: RefundResultStatus, token: GlobalToken) {
    switch (status) {
        case "Complete":
            return { icon: <CheckCircleTwoTone twoToneColor={token.colorSuccess} />, label: "Complete" };
        case "Pending":
            return { icon: <ClockCircleTwoTone twoToneColor={token.colorWarning} />, label: "Pending" };
        case "Failed":
            return { icon: <CloseCircleTwoTone twoToneColor={token.colorError} />, label: "Failed" };
    }
}

export const RefundStatusDisplay = ({ status }: { readonly status: RefundResultStatus }) => {
    const { token } = useToken();
    const display = getRefundStatusDisplay(status, token);
    return (
        <>
            {display.icon} {display.label}
        </>
    );
};
